<template>
  <div class="pe-box">
    <div class="function-introduction">
      <div class="function-introduction-image">
        <swiper class="swiper" :options="swiperOption">
          <swiper-slide v-for="(item, index) in description" :key="index">
            <img class="swiper-img" :src="item.listUrl" />
          </swiper-slide>
        </swiper>
      </div>
      <div
        class="function-introduction-description"
        :class="isActive ? 'actived' : ''"
      >
        <div class="function-introduction-data" style="overflow: hidden">
          <!-- <p class="p1" style="font-size: 1.2rem">
            {{ description[recurrentIndex].title }}
          </p>
          <p class="p2" style="font-size: 0.8rem">
            {{ description[recurrentIndex].subtitle }}
          </p>
          <p class="p4" style="font-size: 1rem; font-weight: 600">
            {{ description[recurrentIndex].secondTitle }}
          </p>
          <p class="p3" style="font-size: 0.7rem">
            {{ description[recurrentIndex].content }}
          </p> -->
          <p class="p1" style="font-size: 1.2rem">
            {{ description[recurrentIndex].header }}
          </p>
          <div
            v-for="(item, index) in description[recurrentIndex].body"
            :key="index"
						style="margin: 4px;"
          >
            <p style="font-size: 1rem">
              {{ item.title }}
            </p>
            <div
              style="font-size: 0.7rem"
              v-for="(itemChild, index) in item.content"
              :key="index"
            >
              <p>{{ itemChild.text }}</p>
            </div>
          </div>
        </div>
        <div class="function-introduction-control-bg" v-show="isActive" />
        <div class="function-introduction-control-box">
          <div class="function-introduction-control" @click="changeHeight">
            {{ isActive ? "もっと見る" : "閉じる" }}
            <img :src="img" alt="" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { Swiper, SwiperSlide, directive } from "vue-awesome-swiper";
import "swiper/swiper-bundle.css";
import {
  zhankai,
  shouhui,
  food2,
  newsIcon,
  ride1
} from "../../images/home/index";
import { mapGetters } from "vuex";
export default {
  computed: {
    imgindex() {
      return this.$store.state.imgindex;
    },
    description() {
      return this.$store.state.description;
    },
    ...mapGetters(["recurrentIndex"])
  },
  data() {
    let _this = this;
    return {
      isActive: true,
      img: zhankai,
      food2,
      newsIcon,
      ride1,
      swiperOption: {
        centeredSlides: true,
        loop: true,
        slidesPerView: "auto",
        autoplay: {
          delay: 2500,
          disableOnInteraction: true
        },
        on: {
          activeIndexChange(swiper) {
            _this.$store.commit("getTextChanged", swiper.realIndex);
          }
        }
      }
    };
  },
  mounted() {
    this.$store.commit("getTextChanged", 0);
  },
  methods: {
    changeHeight() {
      this.isActive = !this.isActive;
      if (this.isActive == true) {
        this.img = zhankai;
      } else {
        this.img = shouhui;
      }
    }
  },

  components: {
    Swiper,
    SwiperSlide
  },
  directives: {
    swiper: directive
  }
};
</script>
<style scoped>
.pebox {
}
.function-introduction {
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.function-introduction-image {
  display: flex;
  align-items: center;
  flex-grow: 1;
  padding-top: 3rem;
}
.function-introduction-description {
  padding: 0.6rem;
  width: 95%;
  transition: 0.5s;
  background: rgba(49, 57, 80, 0.8);
  border-radius: 10px;
  overflow: hidden;
  position: absolute;
  bottom: 1rem;
  z-index: 9;
}
.function-introduction-data {
  margin-bottom: 1.8rem;
}
.function-introduction-data img {
  width: 100%;
}
.function-introduction-data img[src="undefined"] {
  opacity: 0;
  width: 0;
}
.actived {
  height: 17%;
}
.function-introduction-control-box {
  width: 100%;
  position: absolute;
  left: 0;
  bottom: 0rem;
  background: linear-gradient(
    rgba(89, 96, 112, 0) 0%,
    rgba(89, 96, 112, 1) 40%
  );
  height: 1.5rem;
  z-index: 99;
}
.function-introduction-control {
  position: absolute;
  width: 5.5rem;
  border: 1px solid #ffe37a;
  left: 50%;
  margin-left: -2.5rem;
  border-radius: 7px;
  text-align: center;
  z-index: 10;
  bottom: 0.2rem;
  color: #ffe37a;
}
.function-introduction-control img {
  width: 0.6rem;
}
.function-introduction-description p {
  color: white;
}
.function-introduction-description .p1 {
  font-size: 1.2rem;
  font-weight: 1000;
}

.function-introduction-control-bg {
  width: 100%;
  height: 2.4rem;
  background: linear-gradient(180deg, rgba(90, 97, 115, 0), #5a6173);
  border-radius: 8.5px;
  position: absolute;
  bottom: 0.8rem;
}
.function-introduction-description .p4 img {
  width: 100%;
}
.swiper {
  width: 100%;
  overflow: visible;
  position: relative;
  top: -10%;
}

.swiper-slide {
  width: 10rem;
}

.swiper-slide-prev {
  filter: alpha(Opacity=60);
  -moz-opacity: 0.6;
  opacity: 0.6;
  transition: all 0.5s linear;
  transform: scale(1);
}

.swiper-slide-active {
  filter: alpha(Opacity=100);
  -moz-opacity: 1;
  opacity: 1;
  transition: all 0.5s linear;
  transform: scale(1.35);
}

.swiper-slide-prev .introduction-box {
  margin-left: 15% !important;
}

.swiper-slide-next {
  filter: alpha(Opacity=60);
  -moz-opacity: 0.6;
  opacity: 0.6;
  transition: all 0.5s linear;
  transform: scale(1);
}

.swiper-slide-next .introduction-box {
  margin-left: -15% !important;
}

.introduction-box {
  height: 100%;
  width: 100%;
}

.swiper-img {
  display: block;
  margin: 0 auto;
  width: 8rem;
}
</style>



// WEBPACK FOOTER //
// src/components/pe-home/modules/function-introduction.vue